import React from 'react';
import { Footer, menuLogo, globalRibbon } from 'dea-shared';
import Home from './home';
import Engage from './engage';
import Explore from './explore';
import Explain from './explain';
import Elaborate from './elaborate';
import Evaluate from './evaluate';
// import backgroundImage from '../assets/images/background.svg';
// import progressBarImage from '../assets/images/global-ribbon.svg';

export default {
  pages: [Home, Engage, Explore, Explain, Elaborate, Evaluate],
  metaData: {
    Footer,
    backgroundImages: {
      // backgroundImage
    },
    menu: {
      logo: <img src={menuLogo} alt="menu logo" />,
      title: 'The Opioid Epidemic',
      subTitle: 'Module 1 of 4'
    },
    progressBarImage: globalRibbon
  }
};



// WEBPACK FOOTER //
// ./src/data/index.js